// extracted by mini-css-extract-plugin
export default {"card":"pZ-z"};